import { render, staticRenderFns } from "./AssignedPaySectionToolPage.vue?vue&type=template&id=888b98a8&scoped=true&"
import script from "./AssignedPaySectionToolPage.vue?vue&type=script&lang=js&"
export * from "./AssignedPaySectionToolPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "888b98a8",
  null
  
)

export default component.exports